export default "__VITE_ASSET__CWR6nhfL__"